import { Box, HorizontalGrid, Text } from '@shopify/polaris';

// type rows = { label: string; value: ReactNode; hint?: string }[]
//   - `hint`: leyenda pequeña que aparece debajo del valor, útil
//     cuando el KPI necesita una mini-explicación (p.ej. cómo se lee
//     la mediana). En tono subdued para no robar protagonismo.
const TotalizeNumbers = ({ rows }) => {
  return (
    <HorizontalGrid columns={{ xs: 1, md: rows.map(() => '1fr').join(' ') }} gap="4">
      {rows.map(({ label, value, hint }) => (
        <Box key={label}>
          <Text variant="headingSm" as="h4">
            {label}
          </Text>
          <Box border="divider" borderRadius="base" minHeight=".5rem" />
          <Text variant="headingXl">{value}</Text>
          {hint && (
            <>
              <Box minHeight=".25rem" />
              <small style={{ textWrap: 'balance' }}>
                <Text variant="bodySm" tone="subdued">
                  {hint}
                </Text>
              </small>
            </>
          )}
        </Box>
      ))}
    </HorizontalGrid>
  );
};

export default TotalizeNumbers;
